export default __webpack_public_path__ + "static/step0-c781257c78125144b85a53639c3de001.jpg";